import React, { useRef, useState } from 'react';
import { TableContent } from 'entities/table/ui/TableContent';
import { useGetDistributionsQuery } from 'features/getDistributions/useGetDistributions';
import { CircularProgress, Stack } from '@mui/material';
import { useSyncState } from 'shared/hooks/useSyncState';
import { useNavigate } from 'react-router-dom';
import { getDate } from 'shared/utils/date';
import { DistributionDrawer } from 'widgets/user/ui/DistributionDrawer';

const fields = [
  { field: 'id', title: 'ID', width: '5%' },
  { field: 'title_ru', title: 'Заголовок', width: '25%' },
  { field: 'notification_type', title: 'Тип уведомления', width: '20%' },
  { field: 'app_types', title: 'Получатели', width: '25%' },
  { field: 'created_dttm', title: 'Дата создания', width: '25%' },
];

const notificationTypes = [
  { title: 'Акции', value: 'action' },
  { title: 'Персональное', value: 'personal' },
  { title: 'Системное', value: 'system' },
  { title: 'Соревнования', value: 'competition' },
];

type DataType = {
  data: {
    items: [];
    page: number;
    size: number;
    total: number;
  };
  currentData: {
    items: [];
    page: number;
    size: number;
    total: number;
  };
  isError: boolean;
  isFetching: boolean;
  isLoading: boolean;
  isSuccess: boolean;
};

export const DistributionList = () => {
  const navigate = useNavigate();
  const [pagination, setPagination] = useState<{
    page: number;
    count: number;
    search: string;
  }>({
    page: 0,
    count: 10,
    search: '',
  });

  const distributions = useGetDistributionsQuery<DataType>({
    page: pagination.page + 1,
    size: pagination.count,
    search: pagination.search,
  });

  const listTable = () => {
    if (distributions.data) {
      return distributions.data.items.map(
        (item: { app_types: Array<string> | []; created_dttm: string; notification_type: string }) => ({
          ...(item as Object),
          app_types: item.app_types.map((type: string) => type.toUpperCase()).join(', '),
          created_dttm: getDate(item.created_dttm, true),
          notification_type: notificationTypes.filter((notif) => notif.value === item.notification_type)[0]?.title,
        }),
      );
    }
    return [];
  };

  const [isShowSearch, setIsShowSearch] = useState(false);
  const searchQuery = useSyncState('');
  const searchRef = useRef('');

  const handleSetSearch = (search: string) => {
    searchQuery.set(search);
    searchRef.current = search;
  };

  function handleSearch() {
    setPagination((prev) => ({
      ...prev,
      search: searchRef.current,
    }));
  }
  const handleClearSearch = () => {
    setIsShowSearch(false);
    searchQuery.set('');
    searchRef.current = '';
    setPagination((prev) => ({
      ...prev,
      search: '',
    }));
  };

  const handleDetail = (id: number) => {
    navigate(`/distributions/${id}`);
  };

  if (distributions.isFetching) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }

  if (distributions.isError) {
    return <Stack alignItems="center">ERROR</Stack>;
  }

  return distributions.isSuccess ? (
    <>
      <TableContent
        searchPlaceholder="Поиск по заголовку"
        title="Список уведомлений"
        onSearch={() => handleSearch()}
        search={searchQuery.get()}
        setSearch={handleSetSearch}
        isShowSearch={isShowSearch}
        onShowSearch={(showSearch) => setIsShowSearch(showSearch)}
        onClearSearch={handleClearSearch}
        fields={fields}
        list={{ list: listTable() }}
        count={distributions.data.total}
        page={pagination.page}
        perPage={pagination.count}
        onPageChange={(_, page) => {
          setPagination((prev) => ({ ...prev, page }));
        }}
        onRowsPerPageChange={(e) => {
          setPagination(() => ({
            page: 0,
            count: e.target.value as any,
            search: pagination.search,
          }));
        }}
        onRowClick={handleDetail}
      />

      <DistributionDrawer />
    </>
  ) : null;
};
